import { InjectionToken } from '@angular/core';

export interface AvTelemetryUploadConfig {
  uploadIntervalMs: number;
  severeDebounceMs: number;
  /** Verified against the `EventName` union in amazon-chime-sdk-js (298462). */
  severeEventNames: readonly string[];
  maxRowsPerBatch: number;
  /** The spec caps keepalive at 64KB across all in-flight requests, so this stays under it. */
  maxKeepaliveBytes: number;
}

export const AV_TELEMETRY_UPLOAD_DEFAULTS: AvTelemetryUploadConfig = {
  uploadIntervalMs: 60_000,
  severeDebounceMs: 10_000,
  severeEventNames: [
    'signalingDropped',
    'connectionDidBecomePoor',
    'sendingAudioFailed',
    'receivingAudioDropped',
    'meetingFailed',
    'meetingStartFailed',
    // Recovery events drain the outage backlog once connectivity is proven.
    'meetingReconnected',
    'connectionDidBecomeGood',
  ],
  maxRowsPerBatch: 500,
  maxKeepaliveBytes: 48 * 1024,
};

export const AV_TELEMETRY_UPLOAD_CONFIG = new InjectionToken<AvTelemetryUploadConfig>(
  'AV_TELEMETRY_UPLOAD_CONFIG',
  { factory: () => AV_TELEMETRY_UPLOAD_DEFAULTS }
);

export type AvTelemetryUploadOutcome = 'uploaded' | 'nothingToUpload' | 'failed' | 'skipped';

export interface AvTelemetryUploadResult {
  outcome: AvTelemetryUploadOutcome;
  rowsUploaded: number;
}
